import { padStart } from 'lodash';
import { differenceFromUTC, DEFAULT_HOUR, unavailableDates } from './constants';

function getFromToTime({ day, hours = DEFAULT_HOUR, timeDifferenceGr }) {
  const timeDifference = day.getHours() - day.getUTCHours();
  const [fromRange, toRange] = hours.split('-');
  const [fromHour, fromMin] = fromRange.split(':');
  const [toHour, toMin] = toRange.split(':');

  const newFromHour =
    parseInt(fromHour, 10) + timeDifference - timeDifferenceGr;
  const newToHour = parseInt(toHour, 10) + timeDifference - timeDifferenceGr;
  const fromTime = `${padStart(newFromHour, 2, '0')}:${fromMin}`;
  const toTime = `${padStart(newToHour, 2, '0')}:${toMin}`;

  return { fromTime, toTime };
}

function getTimeRangeInMs({ day, hours = DEFAULT_HOUR }) {
  const [fromRange, toRange] = hours.split('-');
  const [fromHour, fromMin] = fromRange.split(':');
  const [toHour, toMin] = toRange.split(':');

  const fromHourTemp = parseInt(fromHour, 10);
  const fromTime = day.setHours(fromHourTemp, parseInt(fromMin, 10), 0, 0);

  const toHourTemp = parseInt(toHour, 10);
  const toTime = day.setHours(
    toHourTemp > fromHourTemp ? toHourTemp : 24 + toHourTemp,
    parseInt(toMin, 10),
    59,
    999,
  );

  return { fromTime, toTime };
}

function getLimits() {
  const limits = unavailableDates.map((date) => {
    const currentDate = new Date(date.day);
    return {
      ...date,
      ...getTimeRangeInMs({
        day: currentDate,
        hours: date.hours,
      }),
    };
  });

  return limits;
}

export const getUnavailableDay = () => {
  const today = new Date();
  const todayInMs = today.getTime();
  const limits = getLimits();
  const unavailableDay = limits.find(
    (day) => todayInMs >= day.fromTime && todayInMs <= day.toTime,
  );

  if (unavailableDay) {
    const { fromTime, toTime } = getFromToTime({
      day: today,
      timeDifferenceGr: differenceFromUTC,
      hours: unavailableDay.hours,
    });
    unavailableDay.fromTime = fromTime;
    unavailableDay.toTime = toTime;
  }
  return unavailableDay;
};
